export enum AuditModule {
  OMS = "oms",
  // Future: AR = "ar", REBATES = "rebates", etc.
}

export enum AuditActionType {
  PO_INGESTED_EMAIL = "po_ingested_email",
  PO_INGESTED_EDI = "po_ingested_edi",
  DRAFT_CREATED = "draft_created",
  DRAFT_UPDATED = "draft_updated",
  DRAFT_APPROVED = "draft_approved",
  DRAFT_REJECTED = "draft_rejected",
  CHANGE_REQUESTED = "change_requested",
  CHANGE_REVIEWED = "change_reviewed",
  AI_EXTRACTION = "ai_extraction",
  AI_LINE_ITEM_MATCH = "ai_line_item_match",
  AI_CUSTOMER_MATCH = "ai_customer_match",
  AI_REASONING_EXTRACTION = "ai_reasoning_extraction",
  AI_REASONING_CUSTOMER_MATCH = "ai_reasoning_customer_match",
  AI_REASONING_PRODUCT_MATCH = "ai_reasoning_product_match",
  SALES_ORDER_CREATED = "sales_order_created",
  SALES_ORDER_STATUS_CHANGE = "sales_order_status_change",
  ORACLE_SUBMISSION = "oracle_submission",
  ORACLE_SYNC_RESULT = "oracle_sync_result",
  VALIDATION_OVERRIDE = "validation_override",
  // API audit log events — action type is the HTTP verb
  API_GET = "api_get",
  API_POST = "api_post",
  API_PUT = "api_put",
  API_PATCH = "api_patch",
  API_DELETE = "api_delete",
  // Change log events (from audit_change_log Postgres triggers)
  CHANGE_LOG_INSERT = "change_log_insert",
  CHANGE_LOG_UPDATE = "change_log_update",
  CHANGE_LOG_DELETE = "change_log_delete",
}

export interface AuditReportEvent {
  id: string;
  timestamp: string; // ISO 8601
  actionType: AuditActionType;
  actor: { id: string; name: string; type: "user" | "system" | "ai" };
  entityType: string; // "SalesOrder", "StagedCustomerPurchaseOrder", etc.
  entityId: string;
  entityLabel: string; // Human-readable: SO number, PO number, etc.
  purchaseOrderNumber?: string | null; // Customer PO number when available
  salesOrderNumber?: string | null; // Internal SO number (e.g. "1234") when available
  summary: string; // One-line description
  details?: Record<string, unknown>; // AI reasoning, before/after, error messages, etc.
}

export interface AuditReportData {
  module: AuditModule;
  dateRange?: { from: string; to: string };
  generatedAt: string;
  totalEvents: number;
  events: AuditReportEvent[];
  filters?: {
    salesOrderNumbers?: string[];
    purchaseOrderNumbers?: string[];
  };
}

export const EXPORT_FORMATS = ["csv", "pdf"] as const;
export type ExportFormat = (typeof EXPORT_FORMATS)[number];
